import { getPublicationRequest } from 'api/Publications/api';
import { PublicationResponse } from 'api/Publications/types';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';

import { useCallback, useState } from 'react';

const usePublication = () => {
  const [ isLoading, setIsLoading ] = useState<boolean>(false);
  const [ error, setError ] = useState<string>();
  const [ publication, setPublication ] = useState<PublicationResponse>({
    id: 0,
    title: '',
    description: '',
    publicationDate: '',
    authors: '',
    tags: [],
    body: [],
    meta: {
      slug: '',
      locale: 'en',
    },
  });

  const fetchPublication = useCallback((publicationSlug: string, abortController: AbortController) => {
    setIsLoading(true);
    setError(undefined);

    getPublicationRequest(publicationSlug, abortController)
      .then(({ data }) => {
        setPublication(data);
      })
      .catch((reason) => {
        if (!abortController.signal.aborted) {
          setError(getErrorFromPromiseReason(reason));
        }
      })
      .finally(() => {
        if (!abortController.signal.aborted) {
          setIsLoading(false);
        }
      });
  }, []);

  return { publication, isLoading, error, fetchPublication };
};

export default usePublication;
